import { FC } from "react";
import { iterPages } from "../tools/PaginationTools";

interface CustomPaginationProps {
    currentPage: number;
    totalPages: number;
    pageHandler: (value: number) => void;
}

const Pagination: FC<CustomPaginationProps> = (props) => {
    const pagesNumbers = iterPages(props.currentPage, props.totalPages);

    const getPaginationLink = (page: number, index: number) => {
        const isCurrentPage = page === props.currentPage;
        return (
            <li key={index}>
                {page ? (
                    <a
                        href="#"
                        className={`flex items-center justify-center px-4 h-10 leading-tight border-light-border-300 dark:border-dark-border-300 text-light-text-100 dark:text-dark-text-300 bg-light-bg-900 dark:bg-dark-bg-100 hover:bg-gray-100 hover:text-gray-700 ${
                            isCurrentPage
                                ? "text-blue-600 font-bold bg-light-800 hover:bg-blue-100 hover:text-blue-700 z-10"
                                : ""
                        }
                    `}
                        onClick={() => props.pageHandler(page)}
                        style={{
                            borderTopLeftRadius: index === 0 ? "8px" : "0",
                            borderBottomLeftRadius: index === 0 ? "8px" : "0",
                            borderTopRightRadius: index === pagesNumbers.length - 1 ? "8px" : "0",
                            borderBottomRightRadius: index === pagesNumbers.length - 1 ? "8px" : "0",
                        }}
                    >
                        {page}
                    </a>
                ) : (
                    <div className="flex items-center justify-center px-4 h-10 leading-tight border-light-border-300 dark:border-dark-border-300 text-light-text-100 dark:text-dark-text-300 bg-white">
                        ...
                    </div>
                )}
            </li>
        );
    };

    return (
        <nav className="flex justify-center mt-4">
            <ul className="mb-2 ml-2 inline-flex text-base h-10 border-light-border-300 dark:border-dark-border-300 rounded-lg overflow-hidden">
                {pagesNumbers.map((page, index) => getPaginationLink(page, index))}
            </ul>
        </nav>
    );
};
export default Pagination;
